<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="bg-light border-bottom-0 modal-header">
            <h5 class="modal-title">
                {{$t("Verification")}}
            </h5>
            <button
                type="button"
                class="close"
                ref="close"
                data-dismiss="modal"
                aria-label="Close"
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="pt-3">
                <div class="text-center mb-2">
                    <img alt="" width="65" :src="$storeIndex.getImageGobalAssets('email1')" >
                </div>
                <div class="text-center mb-3">
                    <p class="text-muted mb-0">{{$t('Please enter the 6-digit code we sent to: ')}}{{$parent.showEmail}}</p>
                    <p class="text-muted">{{$t('To verify your email.')}} <b>({{$t('Ref No.')}}: <span id="ref_code">{{ $parent.$refs.ModalChangeEmailComp.refCodeId }}</span>) </b></p>
                </div>
                <div class="row col-md-12">
                    <label>{{$t('Verification Code')}}</label>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group form-group-feedback mb-0">
                            <input type="text" :placeholder="$t('Enter verification code...')" id="" class="form-control" v-model="$parent.inputVerficationCode">   
                        </div>
                        <label class="validation-invalid-label" for="variationInfo_code" v-if="$parent.$refs.ModalChangeEmailComp.message != ''">{{ $t($parent.$refs.ModalChangeEmailComp.message) }}</label>
                        <label class="mt-1" for="" v-if="$parent.$refs.ModalChangeEmailComp.countdown > 0 && $parent.$refs.ModalChangeEmailComp.displayCountdown != '0:00' && $parent.$refs.ModalChangeEmailComp.displayCountdown != undefined"><i class="fa-solid fa-rotate-right mr-1"></i>{{ $t("Please try again in")+' '+$parent.$refs.ModalChangeEmailComp.displayCountdown+' '+$t("minute")}}</label>
                        <label class="mt-1" for="" v-else><i class="fa-solid fa-rotate-right mr-1 resend"></i><u @click="resendSendMail" class="resend cursor-pointer">{{ $t("Resend verification code")}}</u></label>
                            
                        
                    </div>
                </div>
                <div class="form-group mt-3 mb-0">
                    <div class="text-center">
                        <button @click="handle" class="btn btn-primary mr-2 btn-ladda btn-ladda-spinner ladda-button" type="button" :class="[loading ? 'disabled' : '']">
                        <i :class="[loading ? 'icon-spinner2 spinner' : 'fa-solid fa-circle-check','mr-1',]"></i>
                        {{ $t("Confirm") }}
                        </button>
                        <!-- <button type="button" class="btn btn-primary mr-2" @click="handle"><i class="fa-solid fa-circle-check mr-1"></i> {{$t('Confirm')}}</button> -->
                        <button type="button" @click="stopCountdown" class="btn btn-light" data-dismiss="modal">{{$t('Cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
    import ModalChangeEmail from './ModalChangeEmail.vue';
    
    export default {
        data () {
            return {
                loading: false,
            }
        },
        components: {
            ModalChangeEmail,
        },
        
        methods: {
            stopCountdown(){
                this.$parent.$refs.ModalChangeEmailComp.countdown = 1;
            },
            handle(){
                this.$root.$emit("handleRegister");
                // this.$root.$refs.ModalChangePhone.handleRegister()
            },
            async resendSendMail(){
                console.log('resendMail');
                await this.$nextTick(() => {
                    this.$parent.$refs.ModalChangeEmailComp.countdown = 600;
                });
                this.$root.$emit("sendMail");
                this.$root.$emit("countDownTimer");
            }
            

            
        }

    }
</script>
<style scoped>
    .resend{
        color: #2196f3 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/central/account/profile/ModalVerifiEmail.vue